"use client"
import React, { Suspense } from "react"
// import { GlobalFooter } from "trimble-terra/GlobalFooter"
import { GlobalFooter } from "trimble-terra"
import { getProfile } from "@/profiles/getProfile"
import './GlobalFooter.css'

interface GlobalFooterData {
  data?: {
    mainLogo: {
      image: string
    },
    text: string
    legalStuffCollection: {
      items: {
        url: string
        text: string
        type: string
        iconImage: {
          image: string
        }
      }[]
    }
  }
}

export default function FormatGlobalFooter(data: GlobalFooterData) {
  const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE);
  const formatLegalStuff = (legalStuff: any) => {
    return legalStuff?.map((item: any) => {
      const prefix = profile.NAV_BASE_URL || "https://www.trimble.com/en"
      const processedUrl = item?.url?.slug ? `${prefix}/en/${item?.url?.slug}` : `${prefix}/en/${item?.url?.url}`

      return {
        ...item,
        url: processedUrl,
        text: item?.text,
        type: item?.type,
        iconImage: item?.iconImage ? { image: {file: { url: item?.iconImage?.image?.url } } } : null,
      }
    })
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <GlobalFooter 
        logo={data?.data?.mainLogo?.image} 
        globalFooterText={data?.data?.text} 
        legalStuff={formatLegalStuff(data?.data?.legalStuffCollection?.items)} 
      />
    </Suspense>
  );
}
